"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_STUDENT_EXAM_HISTORY = exports.QUERY_STUDENT_EXAM_SECTION_RESULTS = exports.QUERY_STUDENT_EXAM_PROGRESSION = void 0;
exports.QUERY_STUDENT_EXAM_PROGRESSION = `
  query getStudentExamProgression($sfPersonAccountId: String!) {
    getStudentExamProgression(sfPersonAccountId: $sfPersonAccountId)
  }
`;
exports.QUERY_STUDENT_EXAM_SECTION_RESULTS = `
  query getStudentExamSectionResults($examUrlSlug: String!) {
    getStudentExamSectionResults(examUrlSlug: $examUrlSlug)
  }
`;
exports.QUERY_STUDENT_EXAM_HISTORY = `
  query getStudentExamHistory($sfPersonAccountId: String!) {
    getStudentExamHistory(sfPersonAccountId: $sfPersonAccountId)
  }
`;
//# sourceMappingURL=student-queries.js.map